<script setup lang="ts">
import { syncRetry } from '@clovyr/pollen/util/sleep';
import { renderMd } from './markdown';

const props = defineProps<{
  content: string;
}>();

const html = computed(() => {
  try {
    return syncRetry(10, () => {
      try {
        return [true, renderMd(props.content)];
      } catch (e) {
        console.warn(e);
        return [false, ''];
      }
    });
  } catch (e) {
    console.warn(e);
    return props.content;
  }
});
</script>

<template>
  <div class="markdown" v-html="html"></div>
</template>

<style lang="scss" scoped>
@use 'core/colors';

.markdown {
  :deep(p:not(:first-child)),
  :deep(div:not(:first-child)),
  :deep(hr:not(:first-child)),
  :deep(h1:not(:first-child)),
  :deep(h2:not(:first-child)),
  :deep(h3:not(:first-child)),
  :deep(h4:not(:first-child)),
  :deep(h5:not(:first-child)),
  :deep(h6:not(:first-child)),
  :deep(code:not(:first-child)),
  :deep(pre:not(:first-child)) {
    margin-top: 16px;
  }

  :deep(ul),
  :deep(ol) {
    list-style-type: disc;
    padding-left: 16px;
  }

  :deep(ol) {
    list-style-type: decimal;
  }

  :deep(code),
  :deep(pre) {
    font-family: 'Courier New', Courier, monospace;
  }
  :deep(a) {
    text-decoration: underline;
    color: colors.color(grey, secondary);
  }
}
</style>
